import { FC, useContext, useEffect, useState } from "react";
import { useMediaQuery } from "@material-ui/core";

import { AppContext } from "contexts";
import * as routes from "routes";
import { getPageURL } from "routes/config";
import { MenuItems } from "services/app/types";
import theme from "theme";
import { desktopHeaderHeight, mobileHeaderHeight } from "theme/constants";

import DesktopHeader from "./DesktopHeader";
import MobileHeader from "./MobileHeader";

interface HeaderProps {
  isListings: boolean;
  sellerSide: boolean;
  menuItems: MenuItems;
}

const Header: FC<HeaderProps> = ({ isListings, sellerSide, menuItems }) => {
  const isMdUp = useMediaQuery(theme.breakpoints.up("md"), { noSsr: true });
  const { navHeight, setNavHeight } = useContext(AppContext);

  const [hidden, setHidden] = useState(false);
  const [prevScrollY, setPrevScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      setPrevScrollY(scrollY);

      if (scrollY > prevScrollY) {
        const hidden = scrollY > navHeight;
        setHidden(hidden);
        setNavHeight(
          hidden ? 0 : isMdUp ? desktopHeaderHeight : mobileHeaderHeight,
        );
      } else {
        setHidden(false);
        setNavHeight(isMdUp ? desktopHeaderHeight : mobileHeaderHeight);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [hidden, isMdUp, navHeight, setNavHeight, prevScrollY]);
  const { user, domainNames } = useContext(AppContext);

  const linkLogin = sellerSide
    ? getPageURL(routes.sellerLogin(), domainNames)
    : getPageURL(routes.directoryLogin(), domainNames);

  const linkLogout = sellerSide
    ? routes.sellerLogout()
    : getPageURL(routes.directoryLogout(), domainNames);

  const linkSignUp = sellerSide
    ? getPageURL(routes.sellerCreateAccount(), domainNames)
    : getPageURL(routes.directorySignUp(), domainNames);

  const isLoggedIn = !!user;

  return (
    <>
      {isMdUp ? (
        <DesktopHeader
          isListings={isListings}
          menuItems={menuItems}
          isLoggedIn={isLoggedIn}
          linkLogin={linkLogin}
          linkLogout={linkLogout}
          linkSignUp={linkSignUp}
          hidden={hidden}
        />
      ) : (
        <MobileHeader
          menuItems={menuItems}
          isLoggedIn={isLoggedIn}
          linkLogin={linkLogin}
          linkLogout={linkLogout}
          linkSignUp={linkSignUp}
          hidden={hidden}
        />
      )}
    </>
  );
};

export default Header;
